import { render, staticRenderFns } from "./layoutFooter.vue?vue&type=template&id=5a3f6d39&scoped=true&"
import script from "./layoutFooter.vue?vue&type=script&lang=js&"
export * from "./layoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./layoutFooter.vue?vue&type=style&index=0&id=5a3f6d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3f6d39",
  null
  
)

export default component.exports